import { RouteProps } from "react-router-dom";
import {
  authPagesMenu,
  componentPagesMenu,
  dashboardPagesMenu,
} from "../menu";

import ChartsHeader from "../pages/_layout/_headers/ChartsHeader";
import ComponentsHeader from "../pages/_layout/_headers/ComponentsHeader";
import ContentHeader from "../pages/_layout/_headers/ContentHeader";
import DefaultHeader from "../pages/_layout/_headers/DefaultHeader";
import FlatDetailsHeader from "../pages/_layout/_headers/FlatDetailsHeader";
import FormHeader from "../pages/_layout/_headers/FormHeader";
import IconHeader from "../pages/_layout/_headers/IconHeader";
import ManageFlatsHeader from "../pages/_layout/_headers/ManageFlatsHeader";
import UtilitiesHeader from "../pages/_layout/_headers/UtilitiesHeader";

import BillingCyclesHeader from "../pages/_layout/_headers/BillingCyclesHeader";
import ReadingEntryHeader from "../pages/_layout/_headers/ReadingEntryHeader";
import ResidentSummaryHeader from "../pages/_layout/_headers/ResidentSummaryHeader";
import UtilitySetupHeader from "../pages/_layout/_headers/UtilitySetupHeader";

import AccountChargesHeader from "../pages/_layout/_headers/AccountChargesHeader";
import AccountExpensesHeader from "../pages/_layout/_headers/AccountExpensesHeader";
import AccountHeadsHeader from "../pages/_layout/_headers/AccountHeadsHeader";
import AccountLedgerHeader from "../pages/_layout/_headers/AccountLedgerHeader";
import AccountReceiptsHeader from "../pages/_layout/_headers/AccountReceiptsHeader";


const headers: RouteProps[] = [
  // {
  //   path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path,
  //   element: null,
  // },
  // {
  //   path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path,
  //   element: null,
  // },
  // { path: pageLayoutTypesPagesMenu.blank.path, element: null },
  { path: authPagesMenu.login.path, element: null },
  { path: authPagesMenu.signUp.path, element: null },
  { path: authPagesMenu.verifyOtp.path, element: null },
  { path: "/apartment-admin", element: null },
  // { path: demoPagesMenu.page404.path, element: null },
  // { path: demoPagesMenu.knowledge.subMenu.grid.path, element: null },
  // { path: dashboardPagesMenu.dashboard.path, element: <DashboardHeader /> },
  // {
  //   path: demoPagesMenu.projectManagement.subMenu.list.path,
  //   element: <DashboardHeader />,
  // },
  // { path: demoPagesMenu.pricingTable.path, element: <DashboardHeader /> },
  // {
  //   path: dashboardPagesMenu.dashboardBooking.path,
  //   element: <DashboardBookingHeader />,
  // },
  // {
  //   path: demoPagesMenu.appointment.subMenu.calendar.path,
  //   element: <DashboardBookingHeader />,
  // },
  // {
  //   path: demoPagesMenu.appointment.subMenu.employeeList.path,
  //   element: <DashboardBookingHeader />,
  // },
  // {
  //   path: demoPagesMenu.listPages.subMenu.listFluid.path,
  //   element: <DashboardBookingHeader />,
  // },
  // {
  //   path: `${demoPagesMenu.editPages.path}/*`,
  //   element: <DashboardBookingHeader />,
  // },
  // {
  //   path: `${demoPagesMenu.appointment.subMenu.employeeID.path}/*`,
  //   element: <DashboardBookingHeader />,
  // },
  // {
  //   path: `${demoPagesMenu.projectManagement.subMenu.itemID.path}/*`,
  //   element: <DashboardBookingHeader />,
  // },
  // {
  //   path: demoPagesMenu.singlePages.subMenu.fluidSingle.path,
  //   element: <ProfilePageHeader />,
  // },
  // {
  //   path: demoPagesMenu.singlePages.subMenu.boxedSingle.path,
  //   element: <ProfilePageHeader />,
  // },
  // {
  //   path: demoPagesMenu.sales.subMenu.transactions.path,
  //   element: <ProfilePageHeader />,
  // },
  // {
  //   path: demoPagesMenu.chat.subMenu.withListChat.path,
  //   element: <ProfilePageHeader />,
  // },
  // {
  //   path: demoPagesMenu.chat.subMenu.onlyListChat.path,
  //   element: <ProfilePageHeader />,
  // },
  // {
  //   path: `${demoPagesMenu.knowledge.subMenu.itemID.path}/:id`,
  //   element: <ProfilePageHeader />,
  // },
  // {
  //   path: demoPagesMenu.crm.subMenu.dashboard.path,
  //   element: <ProfilePageHeader />,
  // },
  // {
  //   path: demoPagesMenu.crm.subMenu.customersList.path,
  //   element: <ProfilePageHeader />,
  // },
  // {
  //   path: `${demoPagesMenu.crm.subMenu.customerID.path}/:id`,
  //   element: <ProfilePageHeader />,
  // },
  // {
  //   path: dashboardPagesMenu.summary.path,
  //   element: <SummaryHeader />,
  // },
  {
    path: dashboardPagesMenu.flats.subMenu.manageFlats.path,
    element: <ManageFlatsHeader />,
  },
  {
    path: dashboardPagesMenu.flats.subMenu.flatDetails.path,
    element: <FlatDetailsHeader />,
  },
    {
    path: dashboardPagesMenu.utilities.subMenu.utilitySetup.path,
    element: <UtilitySetupHeader />,
  },
    {
    path: dashboardPagesMenu.utilities.subMenu.billingCycles.path,
    element: <BillingCyclesHeader />,
  },
  {
    path: dashboardPagesMenu.utilities.subMenu.recordReadings.path,
    element: <ReadingEntryHeader />,
  },
  {
    path: dashboardPagesMenu.residentSummary.path,
    element: <ResidentSummaryHeader />,
  },
{
    path: dashboardPagesMenu.accounts.subMenu.charges.path,
    element: <AccountChargesHeader />,
  },
  {
    path: dashboardPagesMenu.accounts.subMenu.receipts.path,
    element: <AccountReceiptsHeader />,
  },
  {
    path: dashboardPagesMenu.accounts.subMenu.expenses.path,
    element: <AccountExpensesHeader />,
  },
  {
    path: dashboardPagesMenu.accounts.subMenu.ledger.path,
    element: <AccountLedgerHeader />,
  },
  {
    path: dashboardPagesMenu.accounts.subMenu.accountHeads.path,
    element: <AccountHeadsHeader />,
  },



  // {
  //   path: dashboardPagesMenu.staffDetails.path,
  //   element: <ResidentSummaryHeader />,
  // },
  // {
  //   path: demoPagesMenu.gridPages.subMenu.gridBoxed.path,
  //   element: <ProductsHeader />,
  // },
  // {
  //   path: demoPagesMenu.gridPages.subMenu.gridFluid.path,
  //   element: <ProductsHeader />,
  // },
  // {
  //   path: demoPagesMenu.listPages.subMenu.listBoxed.path,
  //   element: <ProductListHeader />,
  // },
  // {
  //   path: demoPagesMenu.sales.subMenu.salesList.path,
  //   element: <ProductListHeader />,
  // },
  // {
  //   path: demoPagesMenu.sales.subMenu.productsGrid.path,
  //   element: <ProductListHeader />,
  // },
  // {
  //   path: `${pageLayoutTypesPagesMenu.asideTypes.path}/*`,
  //   element: <PageLayoutHeader />,
  // },
  // {
  //   path: pageLayoutTypesPagesMenu.pageLayout.subMenu.headerAndSubheader.path,
  //   element: <PageLayoutHeader />,
  // },
  // {
  //   path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyHeader.path,
  //   element: <PageLayoutHeader />,
  // },
  {
    path: `${componentPagesMenu.components.path}/*`,
    element: <ComponentsHeader />,
  },
  {
    path: `${componentPagesMenu.forms.path}/*`,
    element: <FormHeader />,
  },
  {
    path: `${componentPagesMenu.charts.path}/*`,
    element: <ChartsHeader />,
  },
  {
    path: `${componentPagesMenu.content.path}/*`,
    element: <ContentHeader />,
  },
  {
    path: `${componentPagesMenu.utilities.path}/*`,
    element: <UtilitiesHeader />,
  },
  {
    path: `${componentPagesMenu.icons.path}/*`,
    element: <IconHeader />,
  },
  // {
  //   path: `${gettingStartedPagesMenu.gettingStarted.path}/*`,
  //   element: <DocumentationHeader />,
  // },
  // {
  //   path: `${gettingStartedPagesMenu.routes.path}/*`,
  //   element: <DocumentationHeader />,
  // },
  {
    path: `*`,
    element: <DefaultHeader />,
  },
];

export default headers;
